import "./Dimmer.css";
import React from "react";

export const Component = () => <div className="Dimmer" />;

export default Component;
